import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Building2, LogOut, LayoutDashboard, Shield } from "lucide-react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const onLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-xl bg-slate-950/80 border-b border-slate-800/80"
      data-testid="app-navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-brand-logo">
          <div className="h-9 w-9 rounded-lg bg-emerald-400 flex items-center justify-center shadow-[0_0_20px_rgba(0,229,153,0.4)]">
            <Building2 className="h-5 w-5 text-slate-950" strokeWidth={2.5} />
          </div>
          <span className="font-heading font-extrabold text-lg tracking-tight text-white">
            EstateLead <span className="text-emerald-400">Premier</span>
          </span>
        </Link>

        <div className="flex items-center gap-2 sm:gap-3">
          {location.pathname !== "/get-started" && (
            <Link to="/get-started" data-testid="nav-public-capture-btn" className="hidden sm:inline-flex">
              <Button variant="ghost" className="text-slate-300 hover:text-white hover:bg-slate-800">
                Sell / Buy a Home
              </Button>
            </Link>
          )}

          {!user && (
            <Link to="/login" data-testid="nav-agent-login-btn">
              <Button className="bg-emerald-400 text-slate-950 hover:bg-emerald-300 font-semibold rounded-full px-4 sm:px-5 text-sm">
                Agent Login
              </Button>
            </Link>
          )}

          {user && user.role === "agent" && (
            <Link to="/dashboard" data-testid="nav-agent-dashboard-link">
              <Button variant="ghost" className="text-slate-300 hover:text-white hover:bg-slate-800 gap-2">
                <LayoutDashboard className="h-4 w-4" /> Dashboard
              </Button>
            </Link>
          )}

          {user && user.role === "admin" && (
            <Link to="/admin" data-testid="nav-admin-panel-link">
              <Button variant="ghost" className="text-slate-300 hover:text-white hover:bg-slate-800 gap-2">
                <Shield className="h-4 w-4" /> Admin
              </Button>
            </Link>
          )}

          {user && (
            <Button
              onClick={onLogout}
              variant="ghost"
              className="text-slate-400 hover:text-rose-400 hover:bg-slate-800"
              data-testid="nav-logout-btn"
            >
              <LogOut className="h-4 w-4" />
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};
